import BaseBankLogo, { BaseBankLogoProps, BankLogoConfig } from './BaseBankLogo';

type PncLogoProps = Omit<BaseBankLogoProps, 'config' | 'renderLogo'>;

const pncConfig: BankLogoConfig = {
    colors: {
        background: '#ffffff',
        border: '#E2E2E2',
        logo: '#F58025',
    },
    defaultAlt: 'PNC Bank Logo',
};

const renderPncLogo = (colors: { background: string; border?: string; logo: string }) => (
    <path
        d="M32.0017 12.0019C20.9546 12.0019 12 20.9566 12 32.0002C12 43.0456 20.9546 51.9985 32.0017 51.9985C43.0454 51.9985 52 43.0456 52 32.0002C52 20.9566 43.0454 12.0019 32.0017 12.0019ZM21.2445 21.7018L21.2514 21.0282C21.2599 18.8283 22.1739 16.9832 23.4308 16.6506C25.073 16.2141 27.2865 18.1684 29.5051 22.0105L31.5668 25.5814C30.9666 25.6854 30.4601 26.0845 30.0679 26.7666L23.337 38.4293C22.353 40.1261 21.6726 41.6558 21.2889 42.9944C21.2872 42.974 21.2872 42.9535 21.2872 42.9296C21.219 39.8515 21.1576 33.6715 21.2445 21.7018ZM28.458 46.4597L27.8714 46.7939C25.9598 47.8904 23.91 48.02 22.9908 47.0957C21.7919 45.8918 22.3769 42.9979 24.5955 39.1575L26.6623 35.578C27.0563 36.0521 27.6514 36.2874 28.4359 36.2874H41.8977C43.8622 36.2874 45.5249 36.1152 46.8772 35.7809C46.8567 35.7912 46.8414 35.798 46.8209 35.8133C44.1913 37.4078 38.8656 40.5592 28.458 46.4597ZM41.8977 34.8328H37.7691C37.9789 34.2547 37.8902 33.6203 37.498 32.9433L30.7653 21.284C29.7831 19.5821 28.8008 18.2281 27.8322 17.227C27.8544 17.2373 27.8714 17.2475 27.8902 17.2594C30.5863 18.7345 35.9683 21.77 46.2855 27.8307L46.8772 28.1752C48.7803 29.2854 49.9161 30.9958 49.5767 32.2526C49.1351 33.8914 46.3366 34.8328 41.8977 34.8328Z"
        fill={colors.logo}
    />
);

/**
 * PNC Bank logo component with flexible sizing and color variants
 */
function PncLogo(props: PncLogoProps) {
    return <BaseBankLogo {...props} config={pncConfig} renderLogo={renderPncLogo} />;
}

export default PncLogo;
